import * as React from 'react';
import { SVGProps } from 'react';

const IconAddSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M6.5 2.5h-1v3h-3v1h3v3h1v-3h3v-1h-3v-3z" />
  </svg>
);
export default IconAddSizeXs;
